export default __webpack_public_path__ + "paddle_city0aa3f0.svg";